import { render } from "./404.vue?vue&type=template&id=0e316742&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=0e316742&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e316742"]])

export default __exports__